"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
const react_redux_1 = require("react-redux");
const redux_form_1 = require("redux-form");
const index_1 = __importDefault(require("./index"));
const app_1 = require("ducks/app");
// ducks
const households_1 = require("ducks/households");
const contact_infos_1 = require("selectors/contact-infos");
const households_2 = require("selectors/households");
// selectors
const profile_1 = require("selectors/profile");
const mapStateToProps = (state) => {
    const selector = (0, redux_form_1.formValueSelector)('household-member-profile');
    const selectedBirthday = selector(state, 'profile.birthdate');
    const contactInfo = (0, households_2.getSelectedMember)(state)
        ? (0, contact_infos_1.findByPerson)((0, contact_infos_1.getContactInfos)(state), (0, households_2.selectedMemberPersonId)(state))
        : {};
    const profileInfoValues = (0, households_2.getSelectedMember)(state) ? (0, households_2.selectedMemberPerson)(state) : {};
    const contactInfoValues = selector(state, 'contactInfos');
    return {
        initialValues: {
            profile: profileInfoValues,
            contactInfos: (0, contact_infos_1.loadContactInfoFormData)(contactInfo),
        },
        selectedCountry: contactInfoValues ? contactInfoValues.addressCountry : null,
        selectedMember: (0, households_2.getSelectedMember)(state),
        households: (0, households_2.getHouseholds)(state),
        currentProfile: (0, profile_1.getCurrentProfile)(state),
        selectedBirthday,
        contactInfo,
        contactInfos: (0, contact_infos_1.getContactInfos)(state),
    };
};
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = {
    saveSelectedMemberProfileAndContact: households_1.saveSelectedMemberProfileAndContact,
    showSaveNeeded: app_1.showSaveNeeded,
};
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps)(index_1.default);
